import React, { useMemo } from 'react'
import { useAuth } from '../../Context/ContextProvider';
import { Link } from 'react-router-dom';

function SliderSection() {
  const { quickNews } = useAuth()
  
  // Duplicate items to create seamless infinite loop
  // If items are less, duplicate them to fill the space
  const duplicatedNews = useMemo(() => {
    if (!quickNews || quickNews.length === 0) return [];
    
    // Calculate how many times we need to duplicate to have at least 10 items
    const minItems = 10;
    const currentLength = quickNews.length;
    
    if (currentLength >= minItems) {
      // If we have enough items, just duplicate once for seamless loop
      return [...quickNews, ...quickNews];
    } else {
      // Calculate how many duplicates needed to reach at least 10 items
      const duplicatesNeeded = Math.ceil(minItems / currentLength);
      const duplicated = [];
      
      // Create enough duplicates
      for (let i = 0; i < duplicatesNeeded; i++) {
        duplicated.push(...quickNews);
      }
      
      // Duplicate once more for seamless animation loop
      return [...duplicated, ...duplicated];
    }
  }, [quickNews]);
  
  return (
    <div  className='slider_section'>
      <Link style={{color: 'white'}} to="/quick-news">
        <div className='slider_content'>
          {duplicatedNews?.map((item, idx) => {
            return (
              <h5 key={`${item?._id}-${idx}`}>{`${idx+1}. ${item?.title}`}</h5>
            )
          })}
        </div>
      </Link>
    </div>
  )
}

export default SliderSection;